function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.922 1.005L7 1a.667.667 0 01.662.589l.005.078v4.666h4.666a.667.667 0 01.662.589L13 7a.667.667 0 01-.589.662l-.078.005H7.667v4.666a.667.667 0 01-.589.662L7 13a.667.667 0 01-.662-.589l-.005-.078V7.667H1.667a.667.667 0 01-.662-.589L1 7a.667.667 0 01.589-.662l.078-.005h4.666V1.667a.667.667 0 01.589-.662z",
  fill: "currentColor"
});

var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgAdd;